import { KlarnaJS } from '@klarna/web-sdk-types'
import { store } from '@klarna-web-sdk/payment/src/utils/store'
import { SDKConfig } from '@klarna-web-sdk/utils/src/types'

export class KlarnaConfig {
  private sdkConfig: SDKConfig

  constructor(sdkConfig: SDKConfig) {
    this.sdkConfig = sdkConfig
  }

  private setAccountId = async (accountId: string) => {
    this.sdkConfig.accountId = accountId
    store.set('config', { ...this.sdkConfig, accountId })
  }

  /**
   * @hidden
   */
  getPublicAPI(): KlarnaJS['Config'] {
    return {
      setAccountId: this.setAccountId.bind(this),
    }
  }
}

export type KlarnaConfigPublicAPI = ReturnType<typeof KlarnaConfig.prototype.getPublicAPI>
